/**
 * Guest authentication for the Trace backend.
 * Calls POST /auth/login/guest to get a JWT access token.
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;

export interface AuthState {
    token: string | null;
    loading: boolean;
    error: string | null;
}

/**
 * Authenticate as a guest user.
 * Returns the access token from the response.
 */
export async function loginAsGuest(): Promise<string> {
    const res = await fetch(`${API_BASE_URL}/auth/login/guest`, {
        method: 'POST',
    });

    if (!res.ok) {
        throw new Error(`Guest login failed (${res.status})`);
    }

    const data = await res.json() as { accessToken?: string; access_token?: string };
    const token = data.accessToken ?? data.access_token;
    if (!token) {
        throw new Error('No access token in guest login response');
    }
    return token;
}

/** Create API client config with auth header (same pattern as sandbox). */
export function apiConfig(accessToken: string) {
    return {
        baseURL: API_BASE_URL,
        securityWorker: () => ({ headers: { Authorization: `Bearer ${accessToken}` } }),
        secure: true,
    };
}

/** Blob storage base URL. */
export const BLOB_BASE_URL = (import.meta.env.VITE_BLOB_URL as string || '').replace(/\/$/, '');
